import api from './api';

export const transactionsService = {
  getTransactions: async (page = 1, limit = 25, filters = {}) => {
    const params = new URLSearchParams({ page, limit });
    if (filters.clientId) params.append('client_id', filters.clientId);
    if (filters.type) params.append('type', filters.type);
    if (filters.status) params.append('status', filters.status);
    if (filters.department) params.append('department', filters.department);
    if (filters.dateFrom) params.append('date_from', filters.dateFrom);
    if (filters.dateTo) params.append('date_to', filters.dateTo);
    
    const response = await api.get(`/transactions?${params}`);
    return response.data;
  },

  getTransaction: async (id) => {
    const response = await api.get(`/transactions/${id}`);
    return response.data;
  },

  createTransaction: async (data) => {
    const response = await api.post('/transactions', data);
    return response.data;
  },

  updateTransaction: async (id, data) => {
    const response = await api.put(`/transactions/${id}`, data);
    return response.data;
  },

  updateTransactionStatus: async (id, status) => {
    const response = await api.patch(`/transactions/${id}/status`, { status });
    return response.data;
  },

  updateTransactionAmount: async (id, amount) => {
    const response = await api.patch(`/transactions/${id}/amount`, { amount });
    return response.data;
  },

  updateTransactionDate: async (id, date) => {
    const response = await api.patch(`/transactions/${id}/date`, { date });
    return response.data;
  },

  deleteTransaction: async (id) => {
    const response = await api.delete(`/transactions/${id}`);
    return response.data;
  },

  exportTransactions: async (format = 'csv', filters = {}) => {
    const params = { format };
    if (filters.dateFrom) params.date_from = filters.dateFrom;
    if (filters.dateTo) params.date_to = filters.dateTo;
    if (filters.type) params.type = filters.type;
    if (filters.status) params.status = filters.status;
    if (filters.department) params.department = filters.department;

    const response = await api.get('/export/transactions', {
      params,
      responseType: 'blob',
    });
    return response.data;
  }
};
